export const HotelAvailabilityCalendarComponent = {
  templateUrl:
    './app/ajs/_shared/components/hotel-availability-calendar/hotel-availability-calendar.component.html',
  bindings: {
    booking: '<',
    bookingItem: '<',
    hotel: '<',
    inventory: '<',
    documentDateExchangeRate: '<',
    onHotelAddedToBookingItem: '&',
  },
  controller: HotelAvailabilityCalendarCalendar,
  controllerAs: 'vm',
};

HotelAvailabilityCalendarCalendar.$inject = [
  'CONFIGURATIONS',
  'UtilService',
  'ModalWindowConfirmService',
  'moment',
  'TaxService',
  'ExchangeRateService',
];

function HotelAvailabilityCalendarCalendar(
  config,
  UtilService,
  ModalWindowConfirmService,
  moment,
  TaxService,
  ExchangeRateService
) {
  const vm = this;

  // public properties
  // -----------------------
  vm.UtilService = new UtilService(vm);

  vm.dateDisplay = config.DATE_DISPLAY_SHORT;

  vm.$onChanges = function () {
    vm.priceList = vm.booking.price_list;
    vm.currency = vm.booking.currency;

    let startDate = moment(vm.bookingItem.start_date);
    let endDate = moment(vm.bookingItem.end_date);

    vm.totalNights = endDate.diff(startDate, 'days');

    if (vm.inventory) {
      setHotelRooms();
    }
  };

  // public methods
  // -----------------------
  vm.addUnitPerRoom = function (room, bookedRoom) {
    if (room.totalUnitsPerRoom > 0) {
      let roomFound = vm.roomsSelected.find((hotelRoom) => hotelRoom.id === room.id);

      if (!roomFound) {
        vm.roomsSelected.push(room);
      }
    } else {
      let index = vm.roomsSelected.indexOf(room);

      // To avoid negative values -n
      if (index >= 0) {
        vm.roomsSelected.splice(index, 1);
      }
    }

    // Same value was selected
    if (room.totalUnitsPerRoom === room.lastTotalUnitsPerRoom) {
      // console.log('same value');
      return;
    }
    // Less value - remove from array
    else if (room.totalUnitsPerRoom < room.lastTotalUnitsPerRoom) {
      // console.log('remove from array');
      for (let i = room.lastTotalUnitsPerRoom - 1; i >= room.totalUnitsPerRoom; i--) {
        room.groupPaxesPerRoom.splice(i, 1);
      }
    }
    // Bigger value - add to array
    else {
      // console.log('add to array');
      for (let i = room.lastTotalUnitsPerRoom; i < room.totalUnitsPerRoom; i++) {
        // Adults
        let adults = [];
        for (let a = 1; a <= room.max_occupancy; a++) {
          adults.push(a);
        }

        // Children
        let children = [];
        if (room.max_occupancy > 2 && room.children_allowed) {
          // for (let c = 0; c <= room.max_occupancy-2; c++ ) {
          for (let c = 0; c <= room.max_children_occupancy; c++) {
            children.push(c);
          }
        }

        // Infants
        let infants = [];
        if (room.max_occupancy > 2 && room.children_allowed) {
          for (let i = 0; i <= room.max_occupancy - 2; i++) {
            infants.push(i);
          }
        }

        room.groupPaxesPerRoom.push({
          adults: adults,
          children: children,
          infants: infants,
        });
      }

      // Default values - keep previous
      room.groupPaxesPerRoom.map((groupPaxPerRoom, index) => {
        let defaultTotalAdultsPerUnit = bookedRoom ? bookedRoom.units[index].adults : 2;
        let defaultTotalChildrenPerUnit = bookedRoom ? bookedRoom.units[index].children : 0;
        let defaultTotalInfantsPerUnit = bookedRoom ? bookedRoom.units[index].infants : 0;

        groupPaxPerRoom.totalAdultsPerUnit =
          groupPaxPerRoom.totalAdultsPerUnit || defaultTotalAdultsPerUnit;

        if (room.max_occupancy > 2 && room.children_allowed) {
          groupPaxPerRoom.totalChildrenPerUnit =
            groupPaxPerRoom.totalChildrenPerUnit || defaultTotalChildrenPerUnit;
          groupPaxPerRoom.totalInfantsPerUnit =
            groupPaxPerRoom.totalInfantsPerUnit || defaultTotalInfantsPerUnit;
        }
      });
    }

    room.lastTotalUnitsPerRoom = room.totalUnitsPerRoom;

    // if (calculatePrices){
    vm.calculateHotelRoomsTotalPrice();
    // }
  };

  vm.checkTotalAdultsPerUnit = function (room, groupPaxPerRoom) {
    if (room.max_occupancy > 2 && room.children_allowed) {
      //let maxChildrenAllowed = parseInt(room.max_occupancy) - parseInt(groupPaxPerRoom.totalAdultsPerUnit);

      let availableOccupancy =
        parseInt(room.max_occupancy) - parseInt(groupPaxPerRoom.totalAdultsPerUnit);
      let maxChildrenAllowed =
        availableOccupancy > room.max_children_occupancy
          ? room.max_children_occupancy
          : availableOccupancy;

      // Add children if max > adults
      if (maxChildrenAllowed > 0) {
        // Add children
        for (let c = groupPaxPerRoom.children.length; c <= maxChildrenAllowed; c++) {
          groupPaxPerRoom.children.push(c);
        }

        // Remove children
        if (groupPaxPerRoom.children.length - 1 >= maxChildrenAllowed) {
          for (let c = groupPaxPerRoom.children.length - 1; c > maxChildrenAllowed; c--) {
            groupPaxPerRoom.children.splice(c, 1);
          }

          if (groupPaxPerRoom.totalChildrenPerUnit > maxChildrenAllowed) {
            groupPaxPerRoom.totalChildrenPerUnit = 0;
          }
        }
      } else {
        groupPaxPerRoom.children = [0];
        groupPaxPerRoom.totalChildrenPerUnit = 0;
      }
    }

    vm.calculateHotelRoomsTotalPrice();
  };

  let applyExchangeRateConversion = (amount) =>
    ExchangeRateService.applyExchangeRateConversion(amount, vm.documentDateExchangeRate);

  vm.calculateHotelRoomsTotalPrice = function () {
    // console.log('calculateHotelRoomsTotalPrice');
    if (vm.roomsSelected.length === 0) return;

    let totalUnitsSelected = 0;

    vm.totalAdultsSelected = 0;
    vm.totalChildrenSelected = 0;
    vm.totalInfantsSelected = 0;
    vm.totalSeniorsSelected = 0;

    let productCost = 0;
    let productPrice = 0;

    let clientCommissionPercentage = 0;

    let bookingItemHotelDates = [];

    vm.roomsSelected.forEach((roomSelected) => {
      totalUnitsSelected += roomSelected.totalUnitsPerRoom;

      roomSelected.groupPaxesPerRoom.forEach((groupPaxPerRoom, index) => {
        let unitNumber = index + 1;

        vm.totalAdultsSelected += groupPaxPerRoom.totalAdultsPerUnit;
        vm.totalChildrenSelected += groupPaxPerRoom.totalChildrenPerUnit;
        vm.totalInfantsSelected += groupPaxPerRoom.totalInfantsPerUnit;

        roomSelected.date_rates.forEach(function (dateRate) {
          let pricePerRoomOccupancy = getRatePerRoomOccupancy(
            groupPaxPerRoom.totalAdultsPerUnit,
            groupPaxPerRoom.totalChildrenPerUnit,
            dateRate,
            'price'
          );

          let costPerRoomOccupancy = getRatePerRoomOccupancy(
            groupPaxPerRoom.totalAdultsPerUnit,
            groupPaxPerRoom.totalChildrenPerUnit,
            dateRate,
            'cost'
          );

          bookingItemHotelDates.push({
            day: dateRate.day,
            unit_number: unitNumber,
            adults: groupPaxPerRoom.totalAdultsPerUnit,
            children: groupPaxPerRoom.totalChildrenPerUnit,
            infants: groupPaxPerRoom.totalInfantsPerUnit,
            item_price: pricePerRoomOccupancy,
            item_cost: costPerRoomOccupancy,
            hotel_id: vm.hotel.id,
            hotel_room_id: roomSelected.id,
          });

          productCost += costPerRoomOccupancy;
          productPrice += pricePerRoomOccupancy;

          // TODO: willy it is taken the last, what about the rest per date ?
          clientCommissionPercentage = dateRate.client_commission_percentage;
        });
      });
    });

    // Product taxes based on service date
    vm.hotel.productTaxes = TaxService.setProductTaxes(vm.hotel, vm.bookingItem.start_date);

    let productPurchaseTaxes = vm.hotel.productTaxes.purchaseTaxes;
    let productSaleTaxes = vm.hotel.productTaxes.saleTaxes;

    vm.bookingItem.adults = vm.totalAdultsSelected;
    vm.bookingItem.children = vm.totalChildrenSelected;
    vm.bookingItem.infants = vm.totalInfantsSelected;
    vm.bookingItem.seniors = vm.totalSeniorsSelected;
    vm.bookingItem.quantity = totalUnitsSelected;
    vm.bookingItem.total_rooms = totalUnitsSelected;
    vm.bookingItem.booking_item_hotel_dates = bookingItemHotelDates;

    // Costs
    let item_cost = applyExchangeRateConversion(productCost); // , vm.documentDateExchangeRate setDayCostPrice ?
    let base_cost = TaxService.setBaseCostPrice(
      item_cost,
      vm.bookingItem.price_list,
      productPurchaseTaxes
    );
    let net_cost = base_cost;
    let pickup_cost = 0;
    let dropoff_cost = 0;
    let discount_cost = 0;
    let subtotal_cost = net_cost + pickup_cost + dropoff_cost - discount_cost;
    let tax_cost_percentage = TaxService.getProductTaxesTotalPercentage(productPurchaseTaxes);

    // console.log('base_cost: ', base_cost);
    // console.log('net_cost: ', net_cost);
    // console.log('subtotal_cost: ', subtotal_cost);

    vm.bookingItem.purchase_taxes = TaxService.setProductTaxesAmounts(
      subtotal_cost,
      productPurchaseTaxes
    );

    let tax_cost = TaxService.getProductTaxesTotalAmount(vm.bookingItem.purchase_taxes);
    let total_cost = subtotal_cost + tax_cost;

    vm.bookingItem.item_cost = vm.UtilService.roundNum(item_cost);
    vm.bookingItem.base_cost = vm.UtilService.roundNum(base_cost);
    vm.bookingItem.net_cost = vm.UtilService.roundNum(net_cost);
    vm.bookingItem.discount_cost = vm.UtilService.roundNum(discount_cost); // conversion needed *
    vm.bookingItem.subtotal_cost = vm.UtilService.roundNum(subtotal_cost);
    vm.bookingItem.tax_cost_percentage = tax_cost_percentage;
    vm.bookingItem.tax_cost = vm.UtilService.roundNum(tax_cost);
    vm.bookingItem.total_cost = vm.UtilService.roundNum(total_cost);

    // Prices
    let item_price = applyExchangeRateConversion(productPrice); // , vm.documentDateExchangeRate setDayCostPrice ?
    let base_price = TaxService.setBaseCostPrice(
      item_price,
      vm.booking.price_list,
      productSaleTaxes
    );
    let commission_price = base_price * (clientCommissionPercentage / 100);
    let net_price = base_price - commission_price;
    let pickup_price = 0;
    let dropoff_price = 0;
    let discount_price = 0;
    let subtotal_price = net_price + pickup_price + dropoff_price - discount_price;
    let tax_price_percentage = TaxService.getProductTaxesTotalPercentage(productSaleTaxes);

    // console.log('-----------------');
    // console.log('base_price: ', base_price);
    // console.log('net_price: ', net_price);
    // console.log('subtotal_price: ', subtotal_price);

    if (vm.booking.discount_coupon_id) {
      if (vm.booking.discount_coupon.discount_type === 'percentage') {
        discount_price = subtotal_price * (vm.booking.discount_coupon.value / 100);
        subtotal_price = subtotal_price - discount_price;
      } else {
        discount_price = applyExchangeRateConversion(vm.booking.discount_coupon.value); // vm.documentDateExchangeRate

        subtotal_price =
          (item_price + pickup_price + dropoff_price - discount_price) /
          (tax_price_percentage / 100 + 1);
      }
    }

    vm.bookingItem.sale_taxes = TaxService.setProductTaxesAmounts(subtotal_price, productSaleTaxes);

    let tax_price = TaxService.getProductTaxesTotalAmount(vm.bookingItem.sale_taxes);
    let total_price = subtotal_price + tax_price;

    vm.bookingItem.item_price = vm.UtilService.roundNum(item_price);
    vm.bookingItem.base_price = vm.UtilService.roundNum(base_price);
    vm.bookingItem.commission_price_percentage = clientCommissionPercentage; // productPrice.client_commission_percentage
    vm.bookingItem.commission_price = vm.UtilService.roundNum(commission_price);
    vm.bookingItem.net_price = vm.UtilService.roundNum(net_price);
    vm.bookingItem.pickup_price = 0; // applyExchangeRateConversion(pickup_price);
    vm.bookingItem.dropoff_price = 0; // applyExchangeRateConversion(dropoff_price);
    vm.bookingItem.discount_price = vm.UtilService.roundNum(discount_price); // conversion needed *
    vm.bookingItem.subtotal_price = vm.UtilService.roundNum(subtotal_price);
    vm.bookingItem.tax_price_percentage = tax_price_percentage;
    vm.bookingItem.tax_price = vm.UtilService.roundNum(tax_price);
    vm.bookingItem.total_price = vm.UtilService.roundNum(total_price);
  };

  vm.addHotelToBookingItem = function (day) {
    if (vm.roomsSelected.length === 0) return;

    vm.sendingForm = true;

    vm.bookingItem.children = vm.bookingItem.children ? vm.bookingItem.children : 0;
    vm.bookingItem.infants = vm.bookingItem.infants ? vm.bookingItem.infants : 0;

    let confirmCallback = () => vm.onHotelAddedToBookingItem({ bookingItemObj: vm.bookingItem });

    if (vm.bookingItem.id) {
      let cancelCallback = () => {
        return;
      };

      let modalParams = {
        title: 'UPDATE_BOOKING_ITEM', // CONFIRM_CHANGES
        body: 'UPDATE_BOOKING_ITEM_WARNING',
        mode: 'danger',
        requireConfirmation: true,
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback, cancelCallback);

      return;
    }

    confirmCallback();
  };

  // private methods
  // -----------------------
  function setHotelRooms() {
    vm.roomsSelected = [];

    vm.inventory.map((room) => {
      room.roomMinAvailability = room.min_availability; // start date - end date

      let totalUnitsPerRoom = 0;

      if (vm.bookingItem.id && room.date_rates.length > 0) {
        // Edit
        for (let index = 0; index < vm.bookingItem.booked_rooms.length; index++) {
          if (vm.bookingItem.booked_rooms[index].id === room.id) {
            let bookedRoom = vm.bookingItem.booked_rooms[index];

            totalUnitsPerRoom = bookedRoom.units.length;
            break;
          }
        }

        room.roomMinAvailability = room.roomMinAvailability + totalUnitsPerRoom; // Bookings = totalUnitsPerRoom
      }

      room.unitsPerRoom = [];

      if (room.roomMinAvailability + totalUnitsPerRoom > 0) {
        let maxUnitsPerRoom = room.roomMinAvailability > 9 ? 9 : room.roomMinAvailability;

        // Units
        for (let x = 0; x <= maxUnitsPerRoom; x++) {
          room.unitsPerRoom.push(x);
        }

        room.totalUnitsPerRoom = totalUnitsPerRoom;
        room.lastTotalUnitsPerRoom = room.totalUnitsPerRoom;

        room.groupPaxesPerRoom = [];
      }

      if (vm.bookingItem.id && room.date_rates.length > 0) {
        // Edit
        for (let index = 0; index < vm.bookingItem.booked_rooms.length; index++) {
          if (vm.bookingItem.booked_rooms[index].id === room.id) {
            let bookedRoom = vm.bookingItem.booked_rooms[index];

            room.lastTotalUnitsPerRoom = 0;

            vm.addUnitPerRoom(room, bookedRoom);
            break;
          }
        }

        // vm.calculateHotelRoomsTotalPrice();
      }
    });
  }

  function getRatePerRoomOccupancy(adults, children, dateRate, option) {
    let rate = 0;

    switch (adults) {
      case 1:
        rate = dateRate['single_' + option];
        break;
      case 2:
        rate = dateRate['double_' + option];
        break;
      case 3:
        rate = dateRate['triple_' + option];
        break;
      case 4:
        rate = dateRate['quadruple_' + option];
        break;
      default:
        rate =
          dateRate['quadruple_' + option] + (adults - 4) * dateRate['additional_person_' + option];
        break;
    }

    children = children ? children : 0;

    rate = rate + children * dateRate['child_' + option];

    return rate;
  }
}
